import styled from 'styled-components';
import { COLORS } from '@/constants';

export const FaqBody = styled.div`
  padding: 8px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 0;
`;

export const FaqItem = styled.div`
  padding: 16px 0;
  border-bottom: 1px solid ${COLORS['neutral/100']};

  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
`;

export const FaqQuestion = styled.p`
  font-size: 14px;
  font-weight: 600;
  color: ${COLORS['primary/900']};
  margin: 0 0 6px;
`;

export const FaqAnswer = styled.p`
  font-size: 14px;
  color: ${COLORS['neutral/600']};
  line-height: 1.6;
  margin: 0;
`;
